import { Collapse, Row, Col, Icon } from "antd";
import { withTheme } from "styled-components";
import moment from "moment";
import React, { Component } from "react";

import { Container, Title } from "./style";
import ColorUtil from "../../../util/ColorUtil";
import EmptyModal from "../../modal/EmptyModal";

const Panel = Collapse.Panel;

class RecentVisitFeedback extends Component {
    state = {}

    renderCollapse = (renderPerPage = null) => {
    	const { visit_feedback, theme, visualColorKey } = this.props;
    	const visit_feedback_sort = visit_feedback.sort((a, b) => b.date - a.date);
    	const feedback = (renderPerPage && visit_feedback_sort.length > renderPerPage)
    		? visit_feedback_sort.slice(0, renderPerPage)
    		: visit_feedback_sort;
    	const color = ColorUtil.getVisualizeColor(theme, visualColorKey, 0, 1);
    	return (
    		<Collapse bordered={false} >
    			{
    				feedback.map((value, index) => {
    					<PanelComp data={value} color={color} />;
    				})
    			}
    		</Collapse>
    	);
    }

    render() {
    	const { visit_feedback, theme, visualColorKey } = this.props;
    	const color = ColorUtil.getVisualizeColor(theme, visualColorKey, 0, 1);
    	return (
    		<Container>
    			<Title>Recent visit feedback</Title>
    			{this.renderCollapse(4)}
    			<div style={{ margin: "20px 0 0 16px" }}>
    				{
    					visit_feedback && visit_feedback.length > 4 ?
    						<a style={{ color }} onClick={() => this.refs.modal.showModal()}>
                                Load more
    						</a>
    						:
    						<div style={{ textAlign: "center" }}>
                                No data
    						</div>
    				}
    			</div>
    			<EmptyModal ref='modal' title='Recent visit feedback'>
    				{this.renderCollapse()}
    			</EmptyModal>
    		</Container>
    	);
    }
}

const PanelComp = ({ data: { date, description, user, provider }, color }) => (
	<Panel header={
		<Row>
			<Col span={12}>
				<span style={{ color }}>
					{moment.unix(date).format("DD-MM-YYYY HH:mm")}
				</span>
			</Col>
			<Col span={12}>{description}</Col>
		</Row>
	}>
		<div style={{ marginLeft: 25 }}>
			<Row style={{ marginBottom: 10 }}>
				<Col span={12}>
					<Row>
						<Col span={12}>
							<div style={{ fontSize: 14, fontWeight: "bold" }}>
								<Icon type="user" style={{ marginRight: 10 }} />
                                User
							</div>
						</Col>
						<Col span={12}>
							{
								user.like &&
                                <Icon
                                	type={user.like ? "like" : "dislike"}
                                	style={{ color }} />
							}
						</Col>
					</Row>
				</Col>
				<Col span={12} style={{ color: "#9b9b9b" }}>
					{user.feedback}
				</Col>
			</Row>
			<Row style={{ marginBottom: 0 }}>
				<Col span={12}>
					<Row>
						<Col span={12}>
							<div style={{ fontSize: 14, fontWeight: "bold" }}>
								<Icon type="user" style={{ marginRight: 10 }} />
                                Provider
							</div>
						</Col>
						<Col span={12}>
							{
								provider.like &&
                                <Icon type={provider.like ? "like" : "dislike"}
                                	style={{ color }} />
							}
						</Col>
					</Row>
				</Col>
				<Col span={12} style={{ color: "#9b9b9b" }}>
					{provider.feedback}
				</Col>
			</Row>
		</div>
	</Panel>
);

export default withTheme(RecentVisitFeedback);


// WEBPACK FOOTER //
// ./src/components/report/individual_user/RecentVisitFeedback.js